const COMPLAINT_CONFIG_DRIVER_STEP_1 = 'complaint-config-driver-step-1'
const COMPLAINT_CONFIG_DRIVER_STEP_2 = 'complaint-config-driver-step-2'
const COMPLAINT_CONFIG_DRIVER_STEP_3 = 'complaint-config-driver-step-3'
const COMPLAINT_CONFIG_DRIVER_STEP_4 = 'complaint-config-driver-step-4'

const COMPLAINT_CATEGORY_EDIT_DRIVER_STEP_1 =
  'complaint-category-edit-driver-step-1'
const COMPLAINT_CATEGORY_EDIT_DRIVER_STEP_2 =
  'complaint-category-edit-driver-step-2'
const COMPLAINT_CATEGORY_EDIT_DRIVER_STEP_3 =
  'complaint-category-edit-driver-step-3'
const COMPLAINT_CATEGORY_EDIT_DRIVER_STEP_4 =
  'complaint-category-edit-driver-step-4'

const COMPLAINT_CONFIG_STEPS_OBJECT = [
  {
    element: '#' + COMPLAINT_CONFIG_DRIVER_STEP_1,
    popover: {
      description:
        'Nesta tela, você pode configurar o seu canal de denúncia, definindo os e-mails que receberão as notificações, habilitando ou não a identificação do denunciante, e gerenciando as categorias do canal — podendo adicionar novas ou inativar as existentes, conforme a necessidade da sua empresa.',
    },
  },
  {
    element: '#' + COMPLAINT_CONFIG_DRIVER_STEP_2,
    popover: {
      description:
        'Ao ativar esta opção, caso a denúncia não tenha sido respondida, o sistema enviará e-mails automáticos de lembrete aos responsáveis designados pela denúncia. Lembrando que os responsáveis podem ser definidos em Edição de Categoria.',
    },
  },
  {
    element: '#' + COMPLAINT_CONFIG_DRIVER_STEP_3,
    popover: {
      description:
        'Ao ativar esta opção, o denunciante terá a possibilidade de se identificar voluntariamente, caso deseje. É importante lembrar que não é permitido exigir a identificação do denunciante, garantindo o direito ao anonimato e a confidencialidade das informações.',
    },
  },
  {
    element: '#' + COMPLAINT_CONFIG_DRIVER_STEP_4,
    popover: {
      description:
        'Atribua responsáveis, inative as categorias que não forem mais necessárias e crie novas conforme a demanda da sua empresa. Caso as opções indiquem a necessidade de configurar categoria, subcategoria ou opções adicionais, será preciso acessar e ajustar essas configurações. Isso acontece porque, ao definir inicialmente que o canal poderia ter subopções, o sistema exige que você as configure manualmente para que fiquem disponíveis durante o uso.',
    },
  },
]

const COMPLAINT_CATEGORY_EDIT_STEPS_OBJECT = [
  {
    element: '#' + COMPLAINT_CATEGORY_EDIT_DRIVER_STEP_1,
    popover: {
      description:
        'Nesta tela, você pode editar suas categorias de forma completa — adicionando novas opções, ativando ou inativando categorias existentes e atribuindo os responsáveis por cada uma delas.',
    },
  },
  {
    element: '#' + COMPLAINT_CATEGORY_EDIT_DRIVER_STEP_2,
    popover: {
      description:
        'Nos três pontinhos, você encontra as opções para atribuir um responsável à categoria ou inativá-la quando necessário. Caso a categoria já esteja inativa, também é possível reativá-la diretamente por este menu.',
    },
  },
  {
    element: '#' + COMPLAINT_CATEGORY_EDIT_DRIVER_STEP_3,
    popover: {
      description:
        'A edição de categorias não é permitida. Contudo, caso precise realizar alterações, você pode criar uma nova categoria na página anterior com as informações atualizadas.',
    },
  },
  {
    element: '#' + COMPLAINT_CATEGORY_EDIT_DRIVER_STEP_4,
    popover: {
      description:
        'Caso você queira adicionar responsáveis às subopções, basta clicar em "Adicionar opção" e, em seguida, acessar o menu de três pontinhos (ações) para atribuir o responsável à subcategoria desejada.',
    },
  },
]

export default {
  COMPLAINT_CONFIG_DRIVER_STEP_1,
  COMPLAINT_CONFIG_DRIVER_STEP_2,
  COMPLAINT_CONFIG_DRIVER_STEP_3,
  COMPLAINT_CONFIG_DRIVER_STEP_4,
  COMPLAINT_CONFIG_STEPS_OBJECT,
  COMPLAINT_CATEGORY_EDIT_DRIVER_STEP_1,
  COMPLAINT_CATEGORY_EDIT_DRIVER_STEP_2,
  COMPLAINT_CATEGORY_EDIT_DRIVER_STEP_3,
  COMPLAINT_CATEGORY_EDIT_DRIVER_STEP_4,
  COMPLAINT_CATEGORY_EDIT_STEPS_OBJECT,
}
